





























































import Vue from 'vue'
import {MSGR_VK, MSGR_TG, MSGR_MAX, MSGR_VB, MSGR_TT, MSGR_LDP, MSGR_DISCORD} from '@/constants'
export const MSGRS: {[key: string]: {icon: string, color: string, label: string}} = {
  [MSGR_VK]: {
    icon: 'static/img/icons/msgrs/vk_white.svg',
    color: '#0077FF',
    label: 'Vkontakte'
  },
  [MSGR_TG]: {
    icon: 'static/img/icons/msgrs/tg_white.svg',
    color: '#279DD4',
    label: 'Telegram'
  },
  [MSGR_MAX]: {
    icon: 'static/img/icons/msgrs/max.png',
    color: '',
    label: 'MAX'
  },
  [MSGR_VB]: {
    icon: 'static/img/icons/msgrs/vb_white.svg',
    color: '#8527B4',
    label: 'Viber'
  },
  [MSGR_TT]: {
    icon: 'static/img/icons/msgrs/tt_white.svg',
    color: '#697CFF',
    label: 'TamTam'
  },
  [MSGR_LDP]: {
    icon: 'static/img/icons/msgrs/ldp_white.svg',
    color: 'linear-gradient(55.38deg, #F8822D 25.06%, #F8BF2D 65.22%)',
    label: 'Lionsdigital'
  },
  [MSGR_DISCORD]: {
    icon: 'static/img/icons/msgrs/discord_white.svg',
    color: '#5865F2',
    label: 'Discord'
  }
}
export default Vue.extend({
  props: {
    type: String,
    ok: Boolean,
    err: Boolean,
    size: {
      type: Number,
      default: 18
    },
    showLabel: Boolean
  },
  methods: {
    getType (): string {
      switch (this.type) {
        case MSGR_MAX:
          return MSGR_MAX;
          break;
        case MSGR_VK:
          return MSGR_VK;
          break;
        case MSGR_TG:
          return MSGR_TG;
          break;
        case MSGR_VB:
          return MSGR_VB;
          break;
        case MSGR_TT:
          return MSGR_TT;
          break;
        case MSGR_LDP:
          return MSGR_LDP;
          break;
        case MSGR_DISCORD:
          return MSGR_DISCORD;
          break;
        default:
          console.error('Unknow messenger type! ', this.type)
          return ''
          break;
      }
    },
    getPath (): string {
      return MSGRS[this.getType()].icon;
    },
    getColor (): string | undefined {
      return MSGRS[this.getType()].color;
    },
    getLabel (): string {
      return MSGRS[this.getType()].label;
    },
  }
})
